module.exports = __webpack_public_path__ + "static/media/gravity.8dcdec2f.png";